<template>
  <div v-on-click-outside="onClose" class="dropdown">
    <button
      ref="dropdownButtonRef"
      class="dropdown__button"
      @click.prevent="isOpened = !isOpened"
    >
      <span>
        {{ getTranslate(selectedValue.title) }}
      </span>
      <img src="~~/assets/icons/arrow-down.svg" alt="select arrow" />
    </button>
    <ul class="dropdown__list" :class="{ isOpened }">
      <li
        v-for="(item, index) in dropdownList"
        :key="item.id ?? index"
        class="dropdown__item"
        :class="{
          selected: item.id
            ? selectedValue.id === item.id
            : getTranslate(item.title) === getTranslate(selectedValue.title),
        }"
        @click.prevent="onSelectValue(item)"
      >
        {{ getTranslate(item.title) }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { vOnClickOutside } from "@vueuse/components";

const props = defineProps({
  dropdownList: { type: Array, required: true, default: () => [] },
  selectedValue: { type: Object, required: true, default: () => {} },
});

const emits = defineEmits(["onSelectValue"]);

const dropdownButtonRef = ref(null);
const { height: dropdownButtonHeight } = useElementBounding(dropdownButtonRef);

const isOpened = ref(false);

const onClose = () => {
  isOpened.value = false;
};

const getTranslate = (word) => {
  return "string" === typeof word ? _T(word) : getLocalizedName(word);
};

const onSelectValue = (selectedItem) => {
  emits("onSelectValue", selectedItem);
  onClose();
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  width: min(363px, 100%);

  &__button {
    width: 100%;

    @include flex-container(row, space-between, center);

    outline: 1px solid var(--color-sky-light);
    border-radius: 24px;

    background-color: white;

    padding: 8px 16px;

    & span {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      @include mobile {
        @include font(14, 18);
      }
    }

    & img {
      @include fixedHW(16px);
    }
  }

  &__list {
    position: absolute;
    inset: calc(v-bind(dropdownButtonHeight) * 1px + 4px) auto auto 0;
    z-index: 101;

    max-height: 220px;
    width: 100%;

    @include flex-container(column, flex-start);

    outline: 1px solid var(--color-sky-light);
    border-radius: 16px;

    background-color: white;

    visibility: hidden;
    opacity: 0;

    overflow-x: auto;

    &.isOpened {
      visibility: visible;
      opacity: 1;
    }
  }

  &__item {
    padding: 8px;

    cursor: pointer;

    &:first-child {
      border-top-right-radius: inherit;
      border-top-left-radius: inherit;
    }

    &:last-child {
      border-bottom-right-radius: inherit;
      border-bottom-left-radius: inherit;
    }

    &:hover:not(.selected) {
      color: var(--color-primary-base);
      background-color: var(--color-sky-lighter);
    }

    &.selected {
      color: white;
      background-color: var(--color-primary-base);
    }

    @include mobile {
      @include font(14, 18);
    }
  }
}
</style>
